<template>
    <div>
        <Modal v-model="show"
               :title="editFlag? $t('编辑')+$t('网络ACL'): $t('创建')+$t('网络ACL')"
               class="securitygroup-form"
               :mask-closable="false"
               @on-cancel="closeModal()">
            <Form ref="addAclForm"
                  :model="formData"
                  class="slbist-addform"
                  :rules="modalRules"
                  :label-width="100">
                <FormItem :label="`${$t('云环境')}：`"
                          v-if="!editFlag"
                          prop="envId">
                    <Select v-model="formData.envId"
                            filterable
                            @on-change="envChange"
                            style="width:300px">
                        <Option v-for="item in envList"
                                :value="item.value"
                                :key="item.value">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="`${$t('所属项目')}：`"
                          v-if="!editFlag"
                          prop="projectId">
                    <Select style="width:300px"
                            v-model="formData.projectId">
                        <Option v-for="item in projectDataList"
                                :key="item.orgSid"
                                :value="item.orgSid+''">{{item.orgName}}</Option>
                    </Select>

                </FormItem>
                <FormItem :label="`${$t('名称')}:`"
                          prop="name">
                    <Input v-model="formData.name"
                           :placeholder="$t('请输入名称')"
                           class="form-item" />
                </FormItem>
                <FormItem :label="`${$t('描述')}:`"
                          prop="description">
                    <Input v-model="formData.description"
                           type="textarea"
                           :autosize=" { minRows: 6, maxRows: 10 }"
                           class="form-item" />
                </FormItem>
            </Form>
            <div class="submit"
                 slot="footer">
                <Button @click="closeModal()"
                        type="text"
                        style="margin-left: 8px">{{$t('取消')}}</Button>
                <Button type="primary"
                        :loading="loading"
                        @click="submit()">{{ this.editFlag ? $t('保存'): $t('创建')}}</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import API from '@/service/api.js'
// import { isNullOrEntry, getOne } from '@/services/utils.js'
import { notHttp } from '@/service/validator.js'
export default {
    name: 'createacl',
    props: [],
    data () {
        return {
            show: false,
            loading: false,
            editFlag: false,
            aclData: null,
            projectDataList: [], // 项目
            envList: [],
            formData: {
                envId: '',
                envName: '',
                envType: '',
                projectId: '',
                id: '',
                name: '',
                description: '',
                netType: '', // 网络类型
                vpc: '' // 专有网络id
            },
            modalRules: {
                name: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                    { min: 2, max: 128, message: this.$t('字段长度2-128位'), trigger: 'blur' },
                    { validator: notHttp, trigger: 'blur' }
                ],
                description: [
                    { min: 2, max: 256, message: this.$t('字段长度2-256位'), trigger: 'blur' },
                    { validator: notHttp, trigger: 'blur' }
                ],
                envId: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'change' }
                ],
                projectId: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'change' }
                ]
            }
        }
    },
    created () {
        this.getEnvs()
        this.getProject()
    },
    methods: {
        // 查询项目
        getProject () {
            this.projectDataList = []
            this.axios.get(this.urlFormat(API.GET_ACCESS_POLICES_ID_PROJECT, false, [this.$store.state.user.currentUser.info.userSid])).then(res => {
                if (res) {
                    this.projectDataList = res
                    if (this.projectDataList.length > 0) {
                        this.formData.projectId = this.projectDataList[0].orgSid + ''
                    }
                }
            })
        },
        getEnvs () {
            // TODO 查询条件 云环境过滤
            this.envList = []
            this.axios.get(this.urlFormat(API.GET_ENVS, true)).then(res => {
                if (res && res.length) {
                    res.forEach(item => {
                        if (['HuaweiCloud', 'HCSO'].includes(item.cloudEnvType)) {
                            this.envList.push({
                                type: item.cloudEnvType,
                                value: item.id + '',
                                name: item.cloudEnvName
                            })
                        }
                    })
                    if (this.envList.length && this.envList.length > 0) {
                        this.formData.envId = this.envList[0].value
                        this.formData.envType = this.envList[0].type
                        this.formData.envName = this.envList[0].name
                    }
                }
            })
        },
        envChange () {
            this.envList.map(item => {
                if (item.value === this.formData.envId) {
                    this.formData.envId = item.value
                    this.formData.cloudName = item.name
                    this.formData.envType = item.type
                }
            })
        },
        openModal (data) {
            this.show = true
            if (data) {
                this.editFlag = true
                this.formData.name = data.name
                this.formData.envId = data.cloudEnvId
                this.formData.cloudName = data.cloudEnvName
                this.formData.envType = data.cloudEnvType
                this.formData.description = data.description
                this.aclData = data
            }
        },
        closeModal () {
            this.show = false
            // 清空数据
            this.formData.name = null
            this.formData.description = null
            this.loading = false
            this.editFlag = false
        },
        submit () {
            this.loading = true
            this.$refs.addAclForm.validate((valid) => {
                if (valid) {
                    const axiosType = this.editFlag ? 'put' : 'post'
                    const params = {
                        name: this.formData.name,
                        description: this.formData.description,
                        cloudEnvId: this.formData.envId,
                        projectId: this.formData.projectId
                    }
                    if (this.editFlag) {
                        params.id = this.aclData.id
                    }
                    this.axios[axiosType](this.urlFormat(API.FIREWALL, false), params).then(res => {
                        if (res.status) {
                            this.loading = false
                            this.show = false
                            this.$emit('refresh')
                            if (this.editFlag) return
                            // 立即添加规则？跳转路由
                            this.$Modal.confirm({
                                title: this.$t('立即添加规则'),
                                content: this.$t('创建成功，请立即创建网络ACL规则，以便能正常访问该网络ACL关联的实例。'),
                                onOk: () => {
                                    const { href } = this.$router.resolve({
                                        path: `/mgt/network_acl/detail/${res.data.id}`,
                                        query: {
                                            envType: res.data.cloudEnvType,
                                            envName: res.data.cloudEnvName,
                                            envId: res.data.cloudEnvId,
                                            name: res.data.name,
                                            tabName: 'inDirection'
                                        }
                                    })
                                    window.open(href, '_blank')
                                }
                            })
                        } else {
                            this.loading = false
                        }
                    }).catch(e => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.form-item {
    width: 300px;
}
</style>
